// extracted by mini-css-extract-plugin
var _1 = "sxGIqM3ica3sLfU758tD";
var _2 = "sxGIqM3ica3sLfU758tD";
export { _1 as "loading-spinner", _2 as "loadingSpinner" }
